import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface UserFilterOption {
  userId: string | null
  fullName: string
}

interface UserFilterResponse {
  users: UserFilterOption[]
}

const fetchFilterUser = async (): Promise<UserFilterOption[]> => {
  const response = await httpClientPrivate.get<UserFilterResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection/user-filter`,
  )
  return response.data.users
}

const useFilterUser = () => {
  const queryKey = ['useFilterCrashDetectionUser']
  const queryFn = async () => fetchFilterUser()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterUser, useFilterUser }
